import classNames from "classnames";
import { FC } from "react";
import { SingleValueProps } from "react-select";
import { OptionItem } from "../../OptionItem";
import styles from "./styles.module.scss";

/**
 * A selected single value within the ValueContainer.
 */
export const SingleValue: FC<SingleValueProps<OptionItem | null>> = (props) => {
  const { children, innerProps } = props;

  const singleValueClassName = classNames(styles.SingleValue, "single-value");

  return (
    <div {...innerProps} className={singleValueClassName}>
      {children}
    </div>
  );
};
